/**
 * Browser WebRTC adapter using native browser APIs
 */
/**
 * Browser WebRTC implementation using native browser APIs
 * This is the default adapter for browser environments
 */
export class BrowserWebRTCAdapter {
    createPeerConnection(config) {
        return new RTCPeerConnection(config);
    }
    createIceCandidate(candidateInit) {
        return new RTCIceCandidate(candidateInit);
    }
}
